/**
 * @generated SignedSource<<b2a0e1019cd43985b45b3b77ad0efe32>>
 * @relayHash 15b26adb6cdacd8545caf90e1039b0e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3584210832a64972e580874951e084b460db31b8f2f89dd4c590a116dbeda621

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentUnifiedWithSpaceKeyQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  autohighlightsEntityAri?: string | null;
  autohighlightsWorkspaceId?: string | null;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeAudioContent?: boolean | null;
  includeAutohighlights?: boolean | null;
  includeAutomationDiscoveries?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeContentHeader?: boolean | null;
  includeContentHeaderAccess?: boolean | null;
  includeFabricEditorEligibility?: boolean | null;
  includeReactions?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey: string;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedWithSpaceKeyQuery$data = {
  readonly autohighlightsQueryFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  } | null;
  readonly space: {
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_space">;
    } | null;
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
    };
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_space">;
  } | null;
  readonly spaceHomepage: {
    readonly agentSessionsMarker?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly archivedPageBannerStatusFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
    };
    readonly audioContent?: {
      readonly audioProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emoji: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly history: {
        readonly createdBy: {
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
        readonly ownedBy: {
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly links: {
        readonly base: string | null;
        readonly webui: string | null;
      } | null;
      readonly subType: string | null;
      readonly title: string | null;
    } | null;
    readonly audioContentFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"AudioContentFragment_content">;
    } | null;
    readonly body: {
      readonly dynamic: {
        readonly content: {
          readonly id: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null;
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly superbatch: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly bylineClassificationFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
    } | null;
    readonly commentsPanelPermission: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
    };
    readonly contentClassification?: {
      readonly classificationLevelDetails: {
        readonly canManageSpaceSettings: boolean;
        readonly classificationControlSetting: string | null;
        readonly classificationLevel: {
          readonly color: string | null;
          readonly description: string | null;
          readonly guideline: string | null;
          readonly guidelineADF: string | null;
          readonly id: string;
          readonly name: string;
          readonly status: string;
        } | null;
        readonly featureEnabled: boolean;
        readonly isReclassificationPermitted: boolean;
        readonly source: ClassificationLevelSource | null;
        readonly userOverrideSetting: string | null;
      } | null;
      readonly id: string | null;
    } | null;
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_content">;
    } | null;
    readonly contentProperties: {
      readonly draft: {
        readonly contentMode: string | null;
      } | null;
      readonly latest: {
        readonly contentMode: string | null;
        readonly generatedBy?: string | null;
      } | null;
    } | null;
    readonly contentState: {
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null;
    readonly contentStateLastUpdated: {
      readonly value: string;
    } | null;
    readonly contentTitleWithByLine?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
    } | null;
    readonly coverPicture?: {
      readonly coverPictureProperties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
    } | null;
    readonly draftVersion: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly history?: {
      readonly createdBy: {
        readonly displayName: string | null;
      } | null;
      readonly createdDate: string | null;
    } | null;
    readonly id: string | null;
    readonly labels?: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    } | null;
    readonly meetingNotesAutomationDiscoveryFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscoveryFragment_content">;
    } | null;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null;
        readonly coverPictureWidth?: string | null;
        readonly embedded: boolean;
        readonly fabricEditorSupported: boolean | null;
      } | null;
      readonly lastModifiedDate: string | null;
    };
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
    };
    readonly pageRestrictionsContext?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
    } | null;
    readonly pageRestrictionsContextAncestors?: {
      readonly ancestors: ReadonlyArray<{
        readonly hasRestrictions: boolean;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly id: string | null;
    } | null;
    readonly pageTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly reactionsContent?: {
      readonly contentReactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly id: string | null;
    } | null;
    readonly reactionsContentFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
    } | null;
    readonly rendererAssetsMacroOutput?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_content">;
    } | null;
    readonly rendererCoverPicture?: {
      readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
    } | null;
    readonly rendererTitleContentProperties?: {
      readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
    } | null;
    readonly shareAndRestrictButtonData?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
      readonly title: string | null;
    } | null;
    readonly smartFolderProperties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly titleContentProperties?: {
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth: string | null;
        } | null;
      };
      readonly pageTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly type: string | null;
    readonly version: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly confRev: string | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly viewPageContentMode?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
    } | null;
    readonly viewPageLabels?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
    } | null;
  } | null;
};
export type ContentUnifiedWithSpaceKeyQuery = {
  response: ContentUnifiedWithSpaceKeyQuery$data;
  variables: ContentUnifiedWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsEntityAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsWorkspaceId"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAudioContent"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutohighlights"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscoveries"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeader"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderAccess"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFabricEditorEligibility"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v22 = [
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "id"
},
v24 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "type"
},
v26 = {
  "kind": "ScalarField",
  "name": "status"
},
v27 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v28 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v27/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v27/*: any*/)
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "name"
},
v30 = {
  "kind": "ScalarField",
  "name": "color"
},
v31 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v32 = {
  "kind": "ScalarField",
  "name": "value"
},
v33 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v32/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v34 = {
  "kind": "ScalarField",
  "name": "title"
},
v35 = {
  "kind": "ScalarField",
  "name": "key"
},
v36 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v29/*: any*/),
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "subType"
},
v38 = [
  (v35/*: any*/),
  (v32/*: any*/)
],
v39 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v38/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v40 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v41 = {
  "kind": "ScalarField",
  "name": "number"
},
v42 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v43 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v44/*: any*/)
},
v46 = {
  "kind": "ScalarField",
  "name": "when"
},
v47 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v48 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v49 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v48/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "representation"
},
v51 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v41/*: any*/)
  ]
},
v52 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v53 = [
  (v52/*: any*/)
],
v54 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        (v32/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v51/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v53/*: any*/)
            },
            (v52/*: any*/)
          ]
        }
      ]
    }
  ]
},
v55 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v23/*: any*/),
      (v35/*: any*/),
      (v32/*: any*/),
      (v51/*: any*/)
    ]
  }
],
v56 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v57 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v58 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v59 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v60 = {
  "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
  "kind": "LinkedField",
  "name": "frontend",
  "plural": false,
  "selections": (v48/*: any*/)
},
v61 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v60/*: any*/)
  ]
},
v62 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v63 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v64 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v65 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v66 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v67 = {
  "kind": "ScalarField",
  "name": "count"
},
v68 = {
  "kind": "ScalarField",
  "name": "label"
},
v69 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v70 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v67/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v23/*: any*/)
      ]
    }
  ]
},
v71 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "emoji-title-published"
  }
],
v72 = {
  "alias": "emoji",
  "args": (v71/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v23/*: any*/),
        (v32/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v73 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v74 = [
  (v43/*: any*/),
  (v73/*: any*/)
],
v75 = {
  "kind": "ScalarField",
  "name": "webui"
},
v76 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v77 = {
  "alias": "audioProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v32/*: any*/),
        (v35/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
},
v78 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v23/*: any*/),
    (v34/*: any*/),
    (v64/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        (v75/*: any*/)
      ]
    }
  ]
},
v79 = {
  "concreteType": "ClassificationLevelDetails",
  "kind": "LinkedField",
  "name": "classificationLevelDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentDataClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        {
          "kind": "ScalarField",
          "name": "guideline"
        },
        {
          "kind": "ScalarField",
          "name": "guidelineADF"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v30/*: any*/),
        (v29/*: any*/),
        (v26/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "featureEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "source"
    },
    {
      "kind": "ScalarField",
      "name": "isReclassificationPermitted"
    },
    {
      "kind": "ScalarField",
      "name": "canManageSpaceSettings"
    },
    {
      "kind": "ScalarField",
      "name": "classificationControlSetting"
    },
    {
      "kind": "ScalarField",
      "name": "userOverrideSetting"
    }
  ]
},
v80 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v81 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v82 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v55/*: any*/)
    }
  ]
},
v83 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v84 = {
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "themeKey"
    },
    (v29/*: any*/)
  ]
},
v85 = {
  "kind": "ScalarField",
  "name": "background"
},
v86 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v87 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v88 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v89 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v90 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v91 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v92 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v93 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v94 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v95 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v85/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v85/*: any*/),
        (v86/*: any*/),
        (v87/*: any*/),
        (v88/*: any*/),
        (v89/*: any*/),
        (v90/*: any*/),
        (v91/*: any*/),
        (v92/*: any*/),
        (v93/*: any*/),
        (v94/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v96 = {
  "kind": "ScalarField",
  "name": "padding"
},
v97 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v98 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v85/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    (v96/*: any*/),
    (v97/*: any*/)
  ]
},
v99 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v100 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v101 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "autohighlightsEntityAri"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "autohighlightsWorkspaceId"
  }
],
v102 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v103 = [
  (v102/*: any*/),
  (v43/*: any*/)
],
v104 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v103/*: any*/)
},
v105 = {
  "kind": "ScalarField",
  "name": "sourceTemplateEntityId"
},
v106 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v107 = [
  (v102/*: any*/),
  (v25/*: any*/),
  (v43/*: any*/),
  (v106/*: any*/),
  (v73/*: any*/)
],
v108 = [
  (v63/*: any*/),
  (v64/*: any*/),
  (v65/*: any*/)
],
v109 = [
  (v102/*: any*/),
  (v43/*: any*/),
  (v73/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v22/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/),
          (v31/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/)
            ]
          },
          (v49/*: any*/),
          (v54/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ViewPageCommentsPanelPermission_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "commentsPanelPermission"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ArchivedPageBannerV2Status_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "archivedPageBannerStatusFragment"
          },
          {
            "condition": "useContentModeFragment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentModeFragmentProvider_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageContentMode"
              }
            ]
          },
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "useNewContentTopper",
                          "variableName": "useNewContentTopper"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentTitleWithByLine_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTitleWithByLine"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useTitleContentPropertiesForPublishedPage_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererTitleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "CoverPictureQuery_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererCoverPicture"
              }
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "MeetingNotesAutomationDiscoveryFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "meetingNotesAutomationDiscoveryFragment"
              }
            ]
          },
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeAccessButton",
                          "variableName": "includeContentHeaderAccess"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeFabricEditorEligibility",
                          "variableName": "includeFabricEditorEligibility"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v58/*: any*/),
                    (v59/*: any*/),
                    (v61/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "titleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v62/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "coverPicture"
              },
              (v58/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v63/*: any*/),
                    (v64/*: any*/),
                    (v65/*: any*/),
                    (v34/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "shareAndRestrictButtonData"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v63/*: any*/),
                    (v65/*: any*/),
                    (v64/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContext"
              }
            ]
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageLabelsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageLabels"
              },
              {
                "args": (v66/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v67/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v68/*: any*/),
                      (v29/*: any*/),
                      (v69/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v70/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContent"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ReactionsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContentFragment"
              }
            ]
          },
          {
            "condition": "includeAudioContent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v34/*: any*/),
                    (v37/*: any*/),
                    (v72/*: any*/),
                    {
                      "concreteType": "History",
                      "kind": "LinkedField",
                      "name": "history",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "createdBy",
                          "plural": false,
                          "selections": (v74/*: any*/)
                        },
                        {
                          "kind": "LinkedField",
                          "name": "ownedBy",
                          "plural": false,
                          "selections": (v74/*: any*/)
                        }
                      ]
                    },
                    (v76/*: any*/),
                    (v77/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "audioContent"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "AudioContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "audioContentFragment"
              }
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v78/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContextAncestors"
              }
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "BylineClassification_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "bylineClassificationFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v23/*: any*/),
                    (v79/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentClassification"
              }
            ]
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          },
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v44/*: any*/)
                  }
                ]
              },
              (v81/*: any*/)
            ]
          },
          {
            "condition": "isSSR",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererAssetsMacroOutput"
              }
            ]
          },
          (v82/*: any*/)
        ]
      },
      {
        "args": (v83/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_space"
                    }
                  ],
                  "type": "Space"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_space"
                }
              ],
              "type": "Space"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          },
          (v23/*: any*/),
          (v84/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v95/*: any*/),
                  (v98/*: any*/)
                ]
              }
            ]
          },
          (v99/*: any*/),
          (v100/*: any*/)
        ]
      },
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v101/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "preloadAutohighlightsQuery_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "autohighlightsQueryFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v18/*: any*/),
      (v21/*: any*/),
      (v16/*: any*/),
      (v20/*: any*/),
      (v17/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v19/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v22/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/),
          (v31/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v104/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v104/*: any*/),
              (v46/*: any*/)
            ]
          },
          (v49/*: any*/),
          (v54/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "emojiTitlePublished",
                "args": (v71/*: any*/),
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v55/*: any*/),
                "storageKey": "properties(key:\"emoji-title-published\")"
              },
              {
                "alias": "editorProperty",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "editor"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v35/*: any*/),
                      (v32/*: any*/)
                    ]
                  }
                ],
                "storageKey": "properties(key:\"editor\")"
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v60/*: any*/),
                  (v105/*: any*/)
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "homepageId"
                  }
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v107/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v107/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v107/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v73/*: any*/),
                      (v106/*: any*/)
                    ]
                  }
                ]
              },
              (v81/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v62/*: any*/)
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v105/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "includeFabricEditorEligibility",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fabricEditorEligibility"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "contentHash"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeContentHeaderAccess",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v108/*: any*/)
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v58/*: any*/),
              (v59/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v108/*: any*/)
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v66/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v67/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v102/*: any*/),
                      (v23/*: any*/),
                      (v68/*: any*/),
                      (v29/*: any*/),
                      (v69/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v70/*: any*/)
            ]
          },
          {
            "condition": "includeAudioContent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v72/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v109/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v109/*: any*/)
                  }
                ]
              },
              (v76/*: any*/),
              (v77/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v78/*: any*/)
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v79/*: any*/)
            ]
          },
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v103/*: any*/)
                  }
                ]
              },
              (v81/*: any*/)
            ]
          },
          {
            "condition": "isSSR",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "MapOfStringToFormattedBody",
                "kind": "LinkedField",
                "name": "macroRenderedOutput",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  {
                    "concreteType": "FormattedBody",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v50/*: any*/),
                      {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": (v53/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v82/*: any*/)
        ]
      },
      {
        "args": (v83/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v84/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v38/*: any*/)
              },
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v85/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v92/*: any*/),
                      (v86/*: any*/),
                      (v87/*: any*/),
                      (v91/*: any*/),
                      (v88/*: any*/),
                      (v90/*: any*/),
                      (v89/*: any*/),
                      (v97/*: any*/),
                      (v96/*: any*/)
                    ]
                  },
                  (v95/*: any*/),
                  (v98/*: any*/)
                ]
              }
            ]
          },
          (v99/*: any*/),
          (v100/*: any*/)
        ]
      },
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": (v101/*: any*/),
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                  (v102/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryKeyPhrase",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "keyPhrase"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoveryKeyPhraseConnection"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "15b26adb6cdacd8545caf90e1039b0e5",
    "id": "3584210832a64972e580874951e084b460db31b8f2f89dd4c590a116dbeda621",
    "metadata": {},
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String){...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n    ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n    ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n    pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n    coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n    hasInheritedRestrictions@include(if:$includeRestrictions)\n    hasRestrictions@include(if:$includeRestrictions)\n    hasViewRestrictions@include(if:$includeRestrictions)\n    title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n    labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n    contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n    ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n    title@include(if:$includeAudioContent)\n    subType@include(if:$includeAudioContent)\n    emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n    history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n    links@include(if:$includeAudioContent){webui,base}\n    audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n    ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n    ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n    id@include(if:$includeClassification)\n    classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){...ContentHeader_space@include(if:$includeContentHeader),...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "5c231b6f73f88125f1c0d0a52b22a42e";

export default node;
